import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "home-wage-tooltip-content" }
const _hoisted_2 = {
  key: 0,
  class: "home-wage-tooltip-admin-badge"
}
const _hoisted_3 = { class: "home-wage-tooltip-body" }
const _hoisted_4 = { key: 0 }

import { computed, inject, useAttrs } from 'vue';


export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'HomeWageTooltip',
  props: {
    memberVisible: { type: Boolean, default: false }
  },
  setup(__props: any) {



const props = __props;

const attrs = useAttrs();

const injected = inject<{ value: boolean } | boolean>('showWageTooltips', true);

const adminTooltipsEnabled = computed(() => {
  if (typeof injected === 'boolean') return injected;
  if (injected && typeof injected === 'object' && 'value' in injected) return injected.value;
  return true;
});

const enabled = computed(() => props.memberVisible || adminTooltipsEnabled.value);

const showAdminBadge = computed(() => enabled.value && !props.memberVisible);

const tooltipBind = computed(() => {
  const { text, ...rest } = attrs as Record<string, unknown>;
  return rest;
});

const fallbackText = computed(() => {
  const text = attrs.text;
  return typeof text === 'string' ? text : '';
});

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (enabled.value)
    ? (_openBlock(), _createBlock(_component_v_tooltip, _normalizeProps(_mergeProps({ key: 0 }, tooltipBind.value)), _createSlots({
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (showAdminBadge.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "관리자전용"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                (fallbackText.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(fallbackText.value), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _: 2
      }, [
        (_ctx.$slots.activator)
          ? {
              name: "activator",
              fn: _withCtx((slotProps) => [
                _renderSlot(_ctx.$slots, "activator", _normalizeProps(_guardReactiveProps(slotProps)))
              ]),
              key: "0"
            }
          : undefined
      ]), 1040))
    : (_ctx.$slots.activator)
      ? _renderSlot(_ctx.$slots, "activator", {
          key: 1,
          props: {}
        })
      : _createCommentVNode("", true)
}
}

})